import axios from 'axios'

class Buriedpoint {

  // static reportBaseUrl = 'http://192.168.0.6:10005';
  static reportBaseUrl = 'https://report.taurus.cash'

  // static reportBaseUrl = '';

  static get reportUrl () {
    return `${Buriedpoint.reportBaseUrl}/reportclient/producerController/send`
  }

  static buildBody (code, ts, cts, pkg, channel, pn, ip, platform, aid, gaid, taurus_stat_uuid, uid, type, listJson) {
    return {
      code: code,
      ts: ts,
      cts: cts,
      pkg: pkg,
      channel: channel,
      pn: pn,
      ip: ip,
      platform: platform,
      aid: aid,
      gaid: gaid,
      taurus_stat_uuid: taurus_stat_uuid,
      uid: uid,
      type: type,
      listJson: listJson
    }
  }

  // 页面即将跳转/被关掉时用这个：普通 xhr 会被掐断，fetch keepalive 能跨导航送达。
  // 没用 navigator.sendBeacon：report 接口只认 application/json，实测 beacon 发这个
  // content-type 预检虽过但 POST 送不到（503/丢包），换 text/plain 又被接口 415 拒掉。
  // 参数与 point 完全一致，环境没有 fetch 时退回 point
  static pointKeepalive (...args) {
    try {
      if (window.fetch) {
        return fetch(Buriedpoint.reportUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Buriedpoint.buildBody(...args)),
          keepalive: true
        }).catch(() => {})
      }
    } catch (e) {
      // 走下面的 xhr
    }
    return Buriedpoint.point(...args)
  }

  static point (code, ts, cts, pkg, channel, pn, ip, platform, aid, gaid, taurus_stat_uuid, uid, type, listJson) {
    // static point(aid,channel,code,data,gaid,pkg,platform,pn,taurusStatUuid,ts,type,uid) {
    return axios
      .post(Buriedpoint.reportUrl, Buriedpoint.buildBody(code, ts, cts, pkg, channel, pn, ip, platform, aid, gaid, taurus_stat_uuid, uid, type, listJson))
      .then(res => {
        console.log('point', res.data)
        if (res.data.code === 0) {
          return Promise.resolve(res.data)
        }
      })
      .catch(err => {
        console.log('point', err)
        // return Promise.reject(err);
      })
  }
}

export default Buriedpoint
